const dev = 'http://localhost:3001';
const production = 'https://serv.chaino.com.ua';
const HOST = production;

export default  HOST;
